import { useContext } from "react";
import { ShopifyContext } from "~context";

export const useShopifyCheckout = () => {
  return useContext(ShopifyContext);
};
